import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../../url_variables';
import { TostMessageContext } from "../../context/TostMessage";
import ReactLoading from 'react-loading';
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import { SideMenu } from '../../components/sidebar';
import { TopBar } from '../../components/topbar';
import {ButtonSmall} from '../../components/buttons';
import { RouteDisplay } from '../../components/route_display';
import { UserContext } from '../../context/UserContext';
import { ClockLoader } from 'react-spinners';
import { IoCheckmarkCircleSharp, IoTimer } from 'react-icons/io5';

function AssignmentsScreen() {
  const navigate = useNavigate();
    const [cookies] = useCookies();
    const {logOutFunction, userProfile} = useContext(UserContext);
    const {setTostMessage} = useContext(TostMessageContext);
    const [searchParams, setSearchParams] = useState({'order_by': ''});
    const [loading, setLoading] = useState(false);
    const [tasks, setTasks] = useState([]);

    useEffect(() => {
      getClasses();
    }, [])

    useEffect(() => {
      getClasses();
    }, [searchParams])

    const getClasses = async () => {
    setLoading(true);
    try {
        const response = await axios.get(base_url + '/tasks/fetch_tasks.php?order_by=' + searchParams.order_by, {
            headers: {
                "Content-Type": "multipart/form-data",
                token: cookies?.userProfile?.session,
                main_id: cookies?.userProfile?.main_id,
                sub_id: cookies?.userProfile?.sub_id
            },
        });
        if (response.data.code == 403) {
            setTostMessage({
                messageType: "error",
                message: response.data.response,
            });
            logOutFunction()
        }
        if (response.data.status) {
            setLoading(false);
            setTasks(response.data.results);
        } else {
            setLoading(false);
            setTostMessage({
                messageType: "error",
                message: response.data.response,
            });
        }
    } catch (error) {
        setLoading(false);
        setTostMessage({
            messageType: "error",
            message: 'Network error',
        });
    }
  }

  const startTask = async (task_id, task_link, group_id, sub_id) => {
      const formData = new FormData();
        formData.append("task_id", task_id);
        formData.append("group_id", group_id);
        formData.append("sub_id", sub_id);
        try {
            const response = await axios.post(base_url + '/tasks/start-task.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    main_id: cookies?.userProfile?.main_id,
                    sub_id: cookies?.userProfile?.sub_id
                },
            });
            if (response.data.code == 403) {
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
                logOutFunction()
            }
            if (response.data.status) {
                window.open(task_link, '_blank'); 
                window.location.reload()
            } else {
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
            }
        } catch (error) {
            setTostMessage({
                messageType: "error",
                message: 'Network error',
            });
        }
  }

  return (
    <div className="relative h-screen h-full">
        <div className="flex h-screen bg-white">
            {/* Sidebar */}
            <SideMenu />
            {/* Main content */}
            <main className="flex-1 p-8 overflow-y-auto">
                {/* Header */}
                <TopBar />
                <RouteDisplay />
                <div className='flex flex-col justify-start'>
                    <h2 className="text-xl font-semibold mb-6">My Tasks</h2>

                      {/* Filter section */}
                      <div className="flex flex-wrap justify-between items-center mb-6">
                        <div className="flex gap-4 flex-wrap">
                          <div className="flex flex-col items-start gap-4 mt-4 md:mt-0">
                            <span className="text-sm text-gray-700">
                              Order By
                            </span>
                            <select onChange={(e) => setSearchParams({...searchParams, order_by: e.target.value})} className="border h-12 px-4 py-2 rounded-md text-sm text-gray-700 w-52">
                              <option value="">Default</option>
                              <option value={'time_set'}>{'Time set'}</option>
                              <option value={'due_date'}>{'Due date'}</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      {loading ? (
                        <div className='flex justify-center items-center w-fill-available h-full z-[999999] bg-[#ffffff] opacity-[0.6] fixed top-0'>
                              <ClockLoader
                                  color={'#F4D00F'}
                                  loading={loading}
                                  size={60}
                                  aria-label="Loading Spinner"
                                  data-testid="loader1"
                              />
                          </div>
                      ) : (
                      <div className='overflow-x-auto'>
                      <table className="w-full table-auto border-collapse text-sm">
                          <thead className="bg-gray-50 border-b">
                          <tr>
                              <th className="p-4">
                                  <div className="flex items-center gap-1">#</div>
                              </th>
                              <th className="text-left px-2 py-2 font-medium text-gray-600">
                                  <div className="flex items-center gap-1"></div>
                              </th>
                              <th className="text-left px-4 py-2 font-medium text-gray-600">
                                  <div className="flex items-center gap-1">Title</div>
                              </th>
                              <th className="text-left px-4 py-2 font-medium text-gray-600">
                                  <div className="flex items-center gap-1">Class</div>
                              </th>
                              <th className="text-left px-4 py-2 font-medium text-gray-600">
                                  <div className="flex items-center gap-1">Tutor</div>
                              </th>
                              <th className="text-left px-4 py-2 font-medium text-gray-600">
                                  <div className="flex items-center gap-1">Due Date</div>
                              </th>
                              <th className="text-left px-4 py-2 font-medium text-gray-600">
                                  <div className="flex items-center gap-1">Action</div>
                              </th>
                              <th className="text-left px-4 py-2 font-medium text-gray-600">
                                  <div className="flex items-center gap-1">Time Set</div>
                              </th>
                          </tr>
                          </thead>
                          <tbody className="text-gray-700">
                              {tasks?.map((row, index) => (
                                <tr
                                key={index}
                                className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                                >
                                    <td className="px-4 py-2">
                                        {++index}
                                    </td>
                                    <td className="px-2 py-2 font-semibold">
                                      {row.done ? (
                                        <IoCheckmarkCircleSharp size={25} color='#00b47a' />
                                      ) : (
                                        <IoTimer size={25} color='#F4D00F' />
                                      )}
                                    </td>
                                    <td className="px-4 py-2 font-semibold">
                                        {row.task_title}
                                    </td>
                                    <td className="px-4 py-2 font-semibold">
                                        {row.language}
                                    </td>
                                    <td className="px-4 py-2">
                                        {row.tutor}
                                    </td>
                                    <td className={`px-4 py-2 font-semibold ${row.due_date<row.today && 'text-red'} ${row.due_date==row.today && 'text-orange'}`}>
                                        {row.due_date}
                                    </td>
                                    <td className="px-4 py-2">
                                      {row.due_date < row.today ? (
                                        <button className='px-4 py-2 cursor-not-allowed bg-yellow-light rounded-[5px] text-dark'>Start Task</button>
                                      ) : (
                                        <button onClick={() => {startTask(row.task_id, row.task_link, row.group_id, row.sub_id) }} className='px-4 py-2 cursor-pointer bg-yellow rounded-[5px] text-dark'>Start Task</button>
                                      )}
                                    </td>
                                    <td className="px-4 py-2">
                                        {row.time_set}
                                    </td>
                                </tr>
                            ))}
                          </tbody>
                        </table>
                        </div>
                      )}
                </div>
            </main>
        </div>
    </div>
  );
}

export default AssignmentsScreen;
